import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useBreakpointValue,
  useSteps,
  Box,
  Grid,
  Flex,
  Text,
  Divider,
} from "@chakra-ui/react";
import ProgressStepper from "App/BsesPoc/components/common/ProgressStepper/ProgressStepper";
import WorkFlowForm from "../forms/WorkFlowForm";
import ShadowBox from "components/common/ShadowBox/ShadowBox";
import HeadingSS from "App/BsesPoc/components/common/Heading/HeadingSS";
import JSONFormComponent from "./JSONFormComponent";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  defaultSchema : any
};

export default function JSONModal({
  isOpen,
  onClose,
  defaultSchema
}: ModalProps): JSX.Element {
  const isMobileView = useBreakpointValue({ base: true, lg: false });
  // const viewerWidth = useBreakpointValue({ lg: true });
  let width = "97vw";

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={handleCloseModal} size="full" isCentered>
        <ModalOverlay />
        <ModalContent
          position="fixed"
          right={isOpen ? "0" : `-${width}`}
          top="0"
          height="100vh"
          width={!isMobileView ? width : "100vw"}
          animation={`${
            isOpen ? "slideIn" : "slideOut"
          } 0.8s ease-in-out forwards`}
        >
          <ModalHeader
            fontSize={{ base: "1rem", md: "1.6rem" }}
            color="teal.300"
            fontWeight="700"
            p=".6rem .6rem"
            ml="1rem"
            textTransform="capitalize"
          >
            WorkFlow
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody overflow="hidden auto" className="customScrollBar">
            <JSONFormComponent defaultSchema={defaultSchema}/>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
        <style>
          {`
          @keyframes slideIn {
            from {
              right: -${width};
            }
            to {
              right: 0;
            }
          }
          @keyframes slideOut {
            from {
              right: 0;
            }
            to {
              right: -${width};
            }
          }
          `}
        </style>
      </Modal>
    </>
  );
}
